import React from 'react';
import { Config } from '../../../services/Services';

import './OnSaleBanner.scss';

export const OnSaleBanner = () => (
  <div className="mp-on-sale-banner">
    <div className="mp-on-sale-banner-wrap">
      <div className="mp-on-sale-banner-1" />
      <div className="mp-on-sale-banner-2">
        <span
          role="button"
          className="explore-btn"
          onClick={() => location.href = `${Config.get('BaseUrl')}/on-sale`}
        >
          Pogledaj Akcije
        </span>
      </div>
    </div>
  </div>
);
